import { computed } from 'vue';
import { email } from '@vuelidate/validators';
import { validationI18n } from '../validation-i18n';

const isCorrectPhoneNumber = (value: string): boolean =>
  /^(\+7|8)?[\s-]?\(?[0-9]{3}\)?[\s-]?[0-9]{3}[\s-]?[0-9]{2}[\s-]?[0-9]{2}$/.test(
    value,
  );

/**
 * Method for create validation rules for a contacts.  
 * To use validation messages add translations of every validation rule to your ru/kk.json files 
 * 
 * @param messagePath - prefix of all validations in your ru/kk.json locales
 * 
 * @example
 * 
 * ```js
 * const validationRules = createRules('contacts.validations');
 * ```
 * **.../ru.json**
 * ```json
 * { 
 *  "contacts": {
      "validations": {
        "required": "Обязательное поле",
        "invalidPhoneNumber": "Введите корректный номер телефона",
        "invalidEmail": "Введите правильный адрес электронной почты"
      }
    },
 * }
 * ```
 */

export function createRules(messagePath: string) {
  const { required, withI18nMessage } =
    validationI18n.model.useLocalizedValidators(messagePath);

  return computed(() => {
    return {
      contacts: {
        countryCode: {},
        phoneCode: {},
        phone: {
          required,
          invalidPhoneNumber: withI18nMessage(isCorrectPhoneNumber),
        },
        email: {
          required,
          invalidEmail: withI18nMessage(email),
        },
      },
    };
  });
}
